import FileIcon from "Components/Common/FileIcon";
import React from "react";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import { Alert, Card, Col, FormGroup, Row } from "reactstrap";

const SelectSearchFile = ({ validation }: { validation: any }) => {
  /**
   * Formats the size
   */
  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function handleAcceptedFiles(files: any) {
    files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    validation.setFieldValue("selectedFiles", [
      ...validation.values.selectedFiles,
      ...files,
    ]);
  }

  const handleRemoveFile = (fileIndex: number) => {
    const selectedFiles = [...validation.values.selectedFiles];
    selectedFiles.splice(fileIndex, 1);
    validation.setFieldValue("selectedFiles", selectedFiles);
  };

  return (
    <Col md={12} className="">
      <FormGroup className="mb-3">
        <div className="mb-3">
          <h5 className="card-title mb-1">Bulk Search</h5>
          <p className="mb-0 text-muted">
            Download the bulk search template, fill it out, and upload it here
            to initiate a bulk search. We recommend limiting the number of
            search terms to a maximum of 500 for better results.
          </p>
        </div>
        <Dropzone
          multiple
          accept={{
            "text/csv": [".csv"],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
              [".docx"],
            "application/msword": [".doc"],
            "application/pdf": [".pdf"],
          }}
          onDrop={(acceptedFiles) => {
            handleAcceptedFiles(acceptedFiles);
          }}
        >
          {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
            <div
              {...getRootProps()}
              className="w-100 d-flex flex-column align-items-center justify-content-center"
              style={{
                minHeight: 280,
                background: isDragReject
                  ? "#fff7f7"
                  : isDragActive
                  ? "#f0f4ff"
                  : "#f8f9fc",
                border: `2px dashed ${
                  isDragReject
                    ? "#ef4444"
                    : isDragActive
                    ? "#4361ee"
                    : "#d1d9e6"
                }`,
                borderRadius: 10,
                cursor: "pointer",
                userSelect: "none",
                outline: "none",
                padding: "32px 24px",
                transition:
                  "border-color 0.18s ease, background 0.18s ease",
              }}
            >
              <input {...getInputProps()} />

              <div
                className="d-flex align-items-center justify-content-center rounded-circle mb-4"
                style={{
                  width: 72,
                  height: 72,
                  background: isDragReject
                    ? "#fee2e2"
                    : isDragActive
                    ? "#dbeafe"
                    : "#f1f5f9",
                }}
              >
                <i
                  className={
                    isDragReject
                      ? "ri-error-warning-line"
                      : "ri-upload-cloud-2-line"
                  }
                  style={{
                    fontSize: 34,
                    color: isDragReject
                      ? "#ef4444"
                      : isDragActive
                      ? "#3b82f6"
                      : "#64748b",
                  }}
                />
              </div>

              <div
                className="fw-semibold mb-1 text-center"
                style={{ fontSize: 16, color: "#64748b" }}
              >
                {isDragReject
                  ? "Some files are not supported"
                  : isDragActive
                  ? "Drop your files here"
                  : "Drag & drop your files here"}
              </div>
              <div style={{ fontSize: 14, color: "#64748b" }}>
                or{" "}
                <span style={{ textDecoration: "underline" }}>
                  click to browse
                </span>
              </div>

              <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-4">
                {["CSV", "DOC", "DOCX", "PDF"].map((format) => (
                  <span
                    key={format}
                    style={{
                      background: "#94a3b8",
                      color: "#fff",
                      fontSize: 11,
                      fontWeight: 700,
                      padding: "3px 9px",
                      borderRadius: 4,
                      letterSpacing: 0.4,
                    }}
                  >
                    {format}
                  </span>
                ))}
              </div>
            </div>
          )}
        </Dropzone>

        {validation.errors.selectedFiles ? (
          <Alert color="danger" className="mb-xl-0 mt-2">
            {validation.errors.selectedFiles}
          </Alert>
        ) : null}
        <div className="list-unstyled mb-0" id="file-previews">
          {validation.values.selectedFiles.map((f: any, i: any) => {
            return (
              <Card
                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                key={i + "-file"}
              >
                <div className="p-2">
                  <Row className="align-items-center">
                    <Col className="col-auto">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light  rounded fs-24">
                          <FileIcon fileName={f?.name} />
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <Link to="#" className="text-muted font-weight-bold">
                        {f?.name}
                      </Link>
                      <p className="mb-0">
                        <strong>{f?.formattedSize}</strong>
                      </p>
                    </Col>
                    <Col className="col-auto">
                      <button
                        type="button"
                        className="btn btn-sm  bg-danger-subtle"
                        onClick={() => handleRemoveFile(i)}
                      >
                        <i className="ri-delete-bin-fill text-danger"></i>
                      </button>
                    </Col>
                  </Row>
                </div>
              </Card>
            );
          })}
        </div>
      </FormGroup>
    </Col>
  );
};

export default SelectSearchFile;
